import styled from 'styled-components';
import { Input } from '../../../../components/ds';

export const PasswordInput = styled(Input.Password)`
  background-color: var(--color-input-background) !important;

  &:disabled {
    background-color: var(--color-input-background-disabled) !important;
  }

  &.ant-input-disabled {
    background-color: var(--color-input-background-disabled) !important;
  }

  &.ant-input-outlined {
    background-color: var(--color-input-background) !important;
  }

  &.ant-input-outlined.ant-input-disabled {
    background-color: var(--color-input-background-disabled) !important;
  }
`;
